// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "./AuthContext"; // adjust path if needed

// const PublicRoute = ({ children }) => {
//   const { isAuthenticated } = useAuth();

//   if (isAuthenticated) {
//     // Redirect authenticated users away from public pages (like login/register/landing)
//     return <Navigate to="/dashboard" replace />;
//   }
  
//   // Allow non-authenticated users to see public pages
//   return children;
// };

// export default PublicRoute;

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext"; // adjust path if needed

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Let logged-in users access '/client-register' without redirect
  if (isAuthenticated && location.pathname !== "/client-register") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
